const initialState = {
  accountSettings: {},
  accountSettingsLoading: true,
  districtSettings: {},
  staffProfile: {},
};

export default function applicationManager(state = initialState, action) {
  switch (action.type) {
    case 'POPULATE_ACCOUNT_SETTINGS':
      return {
        ...state,
        accountSettings: action.settings,
      };

    case 'SET_ACCOUNT_SETTINGS_LOADING':
      return {
        ...state,
        accountSettingsLoading: action.mode,
      };

    case 'SET_AVATAR_IMAGE_UPLOADING':
      return {
        ...state,
        accountSettings: {
          ...state?.accountSettings,
          avatarImageUploading: action.mode,
        },
      };

    case 'UPDATE_NOTIFICATION_PREFERENCES':
      return {
        ...state,
        accountSettings: {
          ...state.accountSettings,
          prevNotificationPreferences: {
            ...state.accountSettings.notificationPreferences,
          },
          notificationPreferences: action.settings,
        },
      };

    case 'ROLLBACK_NOTIFICATION_PREFERENCES':
      return {
        ...state,
        accountSettings: {
          ...state.accountSettings,
          notificationPreferences: {
            ...state.accountSettings.prevNotificationPreferences,
          },
        },
      };

    case 'ACCOUNT_SETTINGS/POPULATE_DISTRICT_SETTINGS':
      return {
        ...state,
        districtSettings: action.districtSettings,
      };

    case 'ACCOUNT_SETTINGS/POPULATE_STAFF_PROFILE':
      return {
        ...state,
        staffProfile: action.staffProfile,
      };

    default:
      return state;
  }
}
